
export const getPresenceContext = () => ({
  language: window.navigator.language,
  userAgent: window.navigator.userAgent,
  href: window.location.href,
  referrer: window.document.referrer,
});